import api from './api';

export const getAnalyticsSummary = async (interval = '1m') => {
  const response = await api.get(`/analytics/summary?interval=${interval}`);
  return response.data;
};

export const getAppreciationTimeline = async (interval = '1m') => {
  const response = await api.get(`/analytics/timeline?interval=${interval}`);
  return response.data;
};

export const exportAnalyticsData = async (interval = '1m') => {
  const response = await api.get(`/analytics/export?interval=${interval}`, {
    responseType: 'blob'
  });
  return response.data;
};

export const getAtRiskUsers = async (days = 30) => {
  const response = await api.get(`/analytics/at-risk-users?days=${days}`);
  return response.data;
};

export const getDepartmentComparison = async (interval = '1m') => {
  const response = await api.get(`/analytics/department-comparison?interval=${interval}`);
  return response.data;
};
